module.exports = __webpack_public_path__ + "static/media/resurfacingpeelbooster.2e875ed2.png";